import $ from 'jquery';
import BaseButton from '../base-button/base-button';


export default class BurgerButton extends BaseButton{
  init(){
    this.selector='.burger-button';
    super.init();
  }

  toggle(){
    super.toggle();
    this.btn.toggleClass('burger-button--opened',this.toggled);
  }

  reset(){
    super.reset();
    if(this.btn){
      this.btn.removeClass('burger-button--opened');
    }
  }
}
